<template>
  <div class="product-detail-container">
    <div class="product-detail__wrapper" v-if="project">
      <div class="product-detail__base-info">
        <div class="base-info__year scrollObj">
          <p>{{ project.year }}</p>
        </div>
        <div class="base-info__other">
          <div class="other__name">
            <p class="name_cn scrollObj">{{ project.name.cn }}</p>
            <p class="name_en scrollObj">{{ project.name.en }}</p>
          </div>
          <div class="other__location scrollObj">
            <p>{{ project.location.cn }} | {{ project.location.en }}</p>
          </div>
        </div>
      </div>
      <div class="product-detail__cover scrollObj">
        <img
          :src="
            $bowser.mobile
              ? project.inner_big_show.mobile
                ? project.inner_big_show.mobile
                : project.inner_big_show.pc
              : project.inner_big_show.pc
          "
          alt=""
        />
      </div>
      <div class="product-detail__main-content">
        <!-- <div class="content__item scrollObj img">
          <p v-lazyload="'img'">
            <img src="/test.png" data-src="/test.png" alt="" />
          </p>
        </div> -->
        <div
          class="content__item scrollObj"
          :class="[content.type, content.comment ? '--with-hint' : '']"
          v-for="(content, index) in project.content"
          :key="index"
        >
          <p v-if="content.type === 'textarea'" v-html="content.value"></p>
          <p v-else-if="content.type === 'img'" v-lazyload="content.type">
            <img :data-src="content.value" alt="" />
            <span class="hint" v-if="content.comment">{{ content.comment }}</span>
          </p>
          <template v-else-if="content.type === 'scroll'">
            <p
              v-for="(img, multiindex) in content.value"
              :key="multiindex"
              v-lazyload="content.type"
            >
              <img :data-src="img" alt="" />
            </p>
            <span class="hint" v-if="content.comment">{{ content.comment }}</span>
          </template>
        </div>
      </div>
      <div class="product-detail__params-info">
        <div class="info__column" v-for="(col, index) in formatInfo" :key="index">
          <div class="info__row scrollObj" v-for="(row, r) in col" :key="r">
            <p class="row__title">{{ row.key }}</p>
            <p class="row__val">{{ row.val }}</p>
          </div>
        </div>
      </div>
      <page-footer class="product-detail"></page-footer>
      <up-bt v-if="!$bowser.mobile"></up-bt>
    </div>
  </div>
</template>

<script>
import { productDetail } from '@/utils/data';
import pageFooter from '../common/footer.vue';
import upBt from '../common/up-bt.vue';

export default {
  name: 'page-product-detail',
  components: {
    pageFooter,
    upBt,
  },
  data() {
    return {
      project: null,
      info: null,
    };
  },
  computed: {
    formatInfo() {
      const data = this.info;
      const temp = [];
      if (data) {
        data.forEach((item, index) => {
          const i = index % 2;
          if (temp[i] === undefined) {
            temp[i] = [item];
          } else {
            temp[i].push(item);
          }
        });
      }
      return temp;
    },
  },
  beforeRouteEnter(to, from, next) {
    const { id } = to.params;
    productDetail(id).then((res) => {
      next((vm) => {
        vm.setData(res);
      });
    });
  },
  beforeRouteUpdate() {},
  directives: {
    lazyload: {
      bind(el) {
        el.classList.add('loading');
        const { src } = el.querySelector('img').dataset;
        const p = new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            resolve(img);
          };
          img.onerror = (e) => {
            reject(e.type);
          };
          img.src = src;
        });
        p.then((res) => {
          // eslint-disable-next-line no-shadow
          const { width, src, height } = res;
          const sizeClass = width < height ? '-half' : '-full';
          el.classList.add(sizeClass);
          el.querySelector('img').setAttribute('src', src);
        }).catch((err) => {
          console.log(err);
        });
      },
      inserted() {},
      update() {},
    },
  },
  methods: {
    setData(data) {
      const { info, project } = data;
      this.info = info;
      this.project = project;
    },
  },
};
</script>

<style></style>
